import $ from 'jquery';

var sopra, scrollTop, height_cambio_colore;

$(window).load(function() {
    
    var array_elementi = $('.cambio-background').length;
    if ( array_elementi > 0 ) {

        //height_cambio_colore = $('.cambio-background').offset().top - ( $(window).height() / 2 );
        height_cambio_colore = $('.cambio-background').offset().top - $(window).height();

        // Il blocco video viene caricato da un Javascript che quindi va a modificare l'altezza dopo l'evento load di $(window)
        if ($("body").hasClass("home")) { height_cambio_colore = height_cambio_colore + 600; }
        
        sopra = $(document).scrollTop() <= height_cambio_colore;
            // true = sopra al cambio
            // false = sotto al cambio

        scrollTop = $(document).scrollTop();
        if( !sopra ) {
            $('body').addClass('color-inverted');
        } else {
            $('body').removeClass('color-inverted');
        }
        if( scrollTop <= height_cambio_colore ) {
            sopra = true;
        } else {
            sopra = false;
        }

        
    }

});

$(window).scroll(function(){
    scrollTop = $(document).scrollTop();

    if( scrollTop > height_cambio_colore && sopra ) {
        $('body').addClass('color-inverted');
    }
    if( scrollTop <= height_cambio_colore && !sopra ) {
        $('body').removeClass('color-inverted');
    }
    if( scrollTop <= height_cambio_colore ) {
        sopra = true;
    } else {
        sopra = false;
    }
});


// WEBPACK FOOTER //
// ../views/blocks/cambio-background/cambio-background.js